import cx from 'classnames';
import {ReactNode, Fragment} from 'react';
import {useTranslation} from 'react-i18next';

import {Tooltip, Card, Icon} from 'components';

type Props = {
    viewType: 'card' | 'row';
    title: string;
    selected?: boolean;
    tooltip?: string;
    color?: string;
    content: string | ReactNode;
    onClick?: () => void;
};

export const ActivityItem = ({viewType = 'card', title, selected, tooltip, content, onClick, color}: Props) => {
    const {t} = useTranslation();

    return (
        <Fragment>
            {viewType === 'row' &&
                <div className='tw-flex tw-items-center tw-p-2 tw-w-full'>
                    <div className='tw-w-3/5 sm:tw-w-1/2 tw-flex tw-items-center'>
                        <div className='tw-mr-2'>
                            <div className='tw-w-4 tw-h-4 tw-rounded-full' style={{backgroundColor: color}} />
                        </div>
                        <div className='tw-ts-code'>{t(title)}</div>
                    </div>
                    <div>{content}</div>
                </div>}
            {viewType === 'card' &&
                <Card
                    className={cx('tw-border-b-2 tw-rounded', {
                        'tw-opacity-50': !selected,
                        'tw-cursor-pointer': onClick
                    })}
                    style={{
                        borderBottomColor: color
                    }}
                    onClick={onClick}
                >
                    <div className='tw-flex tw-justify-between'>
                        <div className='tw-ts-code'>{t(title)}</div>
                        {tooltip && <Tooltip header={t(tooltip)}><Icon name='question' size='xs' /></Tooltip>}
                    </div>
                    <div>{content}</div>
                </Card>}
        </Fragment>
    );
};
